export default __webpack_public_path__ + "static/media/Task.f484a5bb.svg";